import React from 'react';
import { css, cx } from 'styled-system/css';

import { PropsWithChildren } from '@shaojiang/types/common';

export const paperStyle = css({
  p: { base: '6', lgDown: '4' },
  bg: 'bg.surface',
  boxShadow: 'card',
  borderRadius: 'l2',
});

export function ShaojiangPaper({ children, className }: PropsWithChildren) {
  return <article className={cx(paperStyle, className)}>{children}</article>;
}
